import { render, staticRenderFns } from "./Dashboard-bmw.vue?vue&type=template&id=37b3b069&scoped=true&"
import script from "./Dashboard-bmw.vue?vue&type=script&lang=js&"
export * from "./Dashboard-bmw.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard-bmw.vue?vue&type=style&index=0&id=37b3b069&prod&lang=scss&"
import style1 from "./Dashboard-bmw.vue?vue&type=style&index=1&id=37b3b069&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b3b069",
  null
  
)

export default component.exports